import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';

interface OvriProcessorDetailsPageProps {
  processor: ProcessorDetails;
}

export const OvriProcessorDetailsPage = ({ processor }: OvriProcessorDetailsPageProps) => {
  return (
    <>
      <ProcessorHeader type="ovri" processor={processor} />
      <ProcessorOverviewCard processor={processor} />
      <ProcessorMetricsCard processor={processor} />
    </>
  );
};
